<template>
  <div class="design-row-cell"></div>
</template>

<script>
// PLATFORM
export default {
  name: 'TableCell'
}
</script>
